import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import { CircularProgress, Grid } from '@mui/material';
import React, { useState, useMemo, useEffect } from 'react';
import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';

import { adaptGestionCrediticia, GET_GESTION_CREDITICIA } from '../../../../data/graphQL/queries/Contratos/GestionCrediticia/getGestionCrediticia';
import { adaptEstadoCrediticioArray, GET_ESTADOS_CREDITICIA } from '../../../../data/graphQL/queries/Contratos/GestionCrediticia/getEstadosCrediticia';
import { adaptMotivoBloqueoCrediticiaArray, GET_MOTIVOS_BLOQUEO_CREDITICIO } from '../../../../data/graphQL/queries/Contratos/GestionCrediticia/getMotivosBloqueo';
import { UPDATE_GESTION_CREDITICIA } from '../../../../data/graphQL/mutations/Contratos/GestionCrediticia/UpdateGestionCrediticia.js';
import toast from 'react-hot-toast';
import { adaptNotifCrediticia, ENVIAR_NOTIFICACION_CREDITICIA } from '../../../../data/graphQL/queries/Contratos/GestionCrediticia/enviarNotifCrediticia.js';
import moment from 'moment';

export const TabGestionCrediticia = ({
  contratoEditable,
  fullFormData,
  stepData,
  idEvaluacion,
  handleChangeFullFormData,
  setDataSubmissionCallback,
  estadosCrediticia,
  setEstadosCrediticia,
  pageLoading,
  setPageLoading
}) => {

  const [gestionCrediticia, setGestionCrediticia] = useState(fullFormData?.gestionCrediticia || {});

  const [motivosBloqueo, setMotivosBloqueo] = useState([]);

  //useEffect(() => { setGestionCrediticia(fullFormData?.gestionCrediticia) }, [fullFormData?.gestionCrediticia]);

  useEffect(() => {
    if (!fullFormData?.datosPrincipales?.idCliente) return;
    if (!gestionCrediticiaLoading) {
      getGestionCrediticia({
        variables: {
          idEvaluacion: idEvaluacion || 0,
          codCliente: fullFormData?.datosPrincipales?.idCliente
        }
      });
    }
  }, [fullFormData?.datosPrincipales?.idCliente]);

  const [updateGestionCrediticia] = useMutation(UPDATE_GESTION_CREDITICIA);

  const { data: dataEstadosCrediticia } = useQuery(GET_ESTADOS_CREDITICIA);

  useEffect(() => {
    if (!dataEstadosCrediticia) return;
    setEstadosCrediticia(adaptEstadoCrediticioArray(dataEstadosCrediticia));
  }, [dataEstadosCrediticia]);

  const { data: dataMotivosBloqueoCrediticio } = useQuery(GET_MOTIVOS_BLOQUEO_CREDITICIO);

  useEffect(() => {
    if (!dataMotivosBloqueoCrediticio) return;
    setMotivosBloqueo(adaptMotivoBloqueoCrediticiaArray(dataMotivosBloqueoCrediticio));
  }, [dataMotivosBloqueoCrediticio]);

  const [getGestionCrediticia, { data: dataGestionCrediticia, loading: gestionCrediticiaLoading }] = useLazyQuery(GET_GESTION_CREDITICIA, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataGestionCrediticia) return;
    const gestionCreditData = adaptGestionCrediticia(dataGestionCrediticia);
    // si no hay una gestión para efectuada
    if (gestionCreditData.idEstadoCrediticio === undefined) {
      if (gestionCreditData.autorizacionInmediata) {
        const estadoSatisfactorioId = estadosCrediticia.find((x) => x.displayName.includes('Satisfactorio'))?.id;
        handleChange('idEstadoCrediticio', estadoSatisfactorioId);
        updateGestionCrediticia({
          variables: {
            idEvaluacion: idEvaluacion,
            idEstadoCrediticio: estadoSatisfactorioId
          }
        });
      } else {
        const estadoPendienteId = estadosCrediticia.find((x) => x.displayName.includes('Pendiente'))?.id;
        handleChange('idEstadoCrediticio', estadoPendienteId);
      }
    }

    // clienteCC depende únicamente de autorizacionInmediata, sin importar idEstadoCrediticio
    handleChange('clienteCC', !!gestionCreditData.autorizacionInmediata);

    setGestionCrediticia((prevForm) => ({
      ...gestionCreditData,
      ...prevForm
    }));
  }, [dataGestionCrediticia]);

  const [enviarNotificacionCrediticia, { data: dataEnviarNotificacionCrediticia, loading: sendNotifLoading }] = useLazyQuery(ENVIAR_NOTIFICACION_CREDITICIA);

  useEffect(() => {
    if (!dataEnviarNotificacionCrediticia) return;
    const response = adaptNotifCrediticia(dataEnviarNotificacionCrediticia);
    if (response?.enviada) {
      toast.success('Notificación enviada!');
      handleChange('fechaNotificacionCrediticia', response.fechaNotificacionCrediticia || moment().format('yyyy-MM-DD HH:mm:ss'));
    } else {
      toast.error('Error al enviar la notificación');
    }
  }, [dataEnviarNotificacionCrediticia]);

  const handleChange = (name, value) => {
    setGestionCrediticia((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const tieneFechaNotificacion = useMemo(() => {
    return !!gestionCrediticia.fechaNotificacionCrediticia && moment(gestionCrediticia.fechaNotificacionCrediticia).isValid();
  }, [gestionCrediticia.fechaNotificacionCrediticia]);

  const validatedinputs = useMemo(() => {
    if (!fullFormData.datosPrincipales) return;
    return structuredClone(inputs).map((input) => {
      switch (input.name) {
        case 'clienteCC':
          break;
        case 'notificarArea':
          const { idCliente: financiadorSAP, financiadorParticular } = fullFormData.datosPrincipales;
          const estadoPendiente = estadosCrediticia.find((x) => x.displayName.includes('Pendiente'))?.id === gestionCrediticia.idEstadoCrediticio;

          input.hidden = gestionCrediticia.autorizacionInmediata;
          input.disabled = tieneFechaNotificacion || !(!!financiadorSAP && (financiadorParticular && !!fullFormData?.gestionPresupuestos?.transferenciaParticulares?.titulo || !financiadorParticular) && estadoPendiente);

          input.onClick = () => enviarNotificacionCrediticia({ variables: { idEvaluacion } });
          input.isLoading = sendNotifLoading;
          break;
        case 'fechaNotificacionCrediticia':
          input.hidden = gestionCrediticia.autorizacionInmediata;
          break;
        case 'replacement':
          input.hidden = !gestionCrediticia.autorizacionInmediata;
          break;
        case 'idEstadoCrediticio':
          input.options = estadosCrediticia;
          break;
        case 'idMotivoResolucionCrediticia':
          input.options = motivosBloqueo;
          break;
        default:
          break;
      }
      if (!contratoEditable) {
        input.disabled = true;
      }
      return input;
    });
  }, [
    fullFormData?.datosPrincipales?.idCliente,
    fullFormData?.datosPrincipales?.financiadorParticular,
    fullFormData?.datosPrincipales?.financiadorSAP,
    fullFormData?.gestionPresupuestos?.transferenciaParticulares,
    gestionCrediticia.autorizacionInmediata,
    gestionCrediticia.fechaNotificacionCrediticia,
    gestionCrediticia.idEstadoCrediticio,
    estadosCrediticia,
    motivosBloqueo,
    sendNotifLoading,
    contratoEditable,
    tieneFechaNotificacion
  ]
  );

  useEffect(() => {
    handleChangeFullFormData('gestionCrediticia', gestionCrediticia);
  }, [gestionCrediticia]);

  const handleSubmit = () => {
    handleChangeFullFormData('gestionCrediticia', gestionCrediticia);
  };

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [gestionCrediticia, setDataSubmissionCallback, validatedinputs]);

  if (pageLoading) {
    return (
      <div className='tab-loading-section-contrato'>
        <CircularProgress />
      </div>);

  }

  return <div>
    <Grid
      container
      columnSpacing={3}
      rowSpacing={3}
      columns={100}>

      {validatedinputs?.
        filter((input) => !input.hidden)?.
        map((input, index) =>
          <RenderInputsRowByType
            key={`${input.name}-index${index}`}
            input={input}
            value={gestionCrediticia[input.name]}
            handleChange={handleChange} />

        )}
    </Grid>
  </div>;
};

const inputs = [
  {
    displayName: 'Cliente CC',
    name: 'clienteCC',
    type: 'custom_switch',
    disabled: true,
    col: 15
  },
  {
    displayName: 'Estado',
    name: 'idEstadoCrediticio',
    type: 'select',
    options: [],
    disabled: true,
    col: 18
  },
  {
    displayName: 'Notificar Area Crediticia',
    name: 'notificarArea',
    type: 'button',
    disabled: true,
    onClick: undefined,
    col: 25
  },
  {
    displayName: 'Fecha de Notificación',
    name: 'fechaNotificacionCrediticia',
    type: 'datetime',
    disabled: true,
    col: 25
  },
  {
    //Si los dos inputs anteriores no tienen que renderizarse, se muestra este item en su lugar por el espaciado
    name: 'replacement',
    type: 'item',
    col: 50,
    hidden: true
  },
  {
    displayName: 'Motivo de bloqueo/rechazo',
    name: 'idMotivoResolucionCrediticia',
    type: 'select',
    disabled: true,
    col: 50
  },
  {
    displayName: 'Fecha y Hora',
    name: 'fechaEstadoCrediticio',
    type: 'datetime',
    disabled: true,
    col: 20
  },
  {
    displayName: 'Usuario',
    name: 'usuarioAutorizador',
    type: 'string',
    disabled: true,
    col: 30
  },
  {
    displayName: 'Observación',
    name: 'observacionCrediticia',
    type: 'long_string',
    disabled: true,
    col: 100
  }];